import React, { useCallback, useState } from 'react';
import Modal from 'components/modal/modalComponent';
import { useGetFileFromStorage } from 'hooks/useGetFileFromStorage';
import { ReactComponent as FileDownloadIcon } from 'assets/icons/file-download.svg';
import { ModalButtonProps } from 'components/modal/modal.interfaces';
import { genericActionsIds } from 'utilities/constants';
import { useGetGenericActions } from 'hooks/useGetGenericActions';

interface IChatMediaModalProps {
  src?: string | null;
  title?: string;
  setSrc: React.Dispatch<React.SetStateAction<string | null | undefined>>;
}

const ChatMediaModal: React.FC<IChatMediaModalProps> = ({
  src,
  setSrc,
  title = 'Media',
}) => {
  const { data: genericAction } = useGetGenericActions({
    locale: 'en',
    genericActionId: [genericActionsIds.CLOSE, genericActionsIds.DOWNLOAD],
  });
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setSrc(null);
  };
  const { downloadFileFromUrl } = useGetFileFromStorage();
  const onDownloadFile = useCallback(() => {
    setLoading(true);
    return downloadFileFromUrl(src as string, 'photo').finally(() =>
      setLoading(false),
    );
  }, [downloadFileFromUrl, src]);

  const Buttons: ModalButtonProps[] = [
    {
      label: genericAction?.[genericActionsIds.CLOSE].close,
      onClick: handleClose,
      testID: 'close',
    },
    {
      label: genericAction?.[genericActionsIds.DOWNLOAD].download,
      onClick: onDownloadFile,
      Icon: FileDownloadIcon,
      disabled: loading,
      showSpinner: loading,
      type: 'underline',
      iconPosition: 'left',
      testID: 'download',
    },
  ];

  if (!src) {
    return null;
  }

  return (
    <Modal
      isOpen={true}
      onClose={handleClose}
      title={title}
      buttons={Buttons}
      contentPaddingX="grow px-0 desktop:px-30"
      contentPaddingY="py-0 desktop:py-30"
      buttonsContainerCustomClass="justify-between flex-row w-full"
      disableMobileGrow
      contentContainerDefaultBackground="bg-white !py-0"
      contentContainerDefaultBorder="border-b-2 border-base-content"
    >
      <div className="flex bg-transparent overflow-hidden w-full h-[600px] bg-cover bg-center justify-center items-center">
        <img
          src={src}
          alt="Default Image"
          className="w-full h-full object-scale-down"
        />
      </div>
    </Modal>
  );
};

export default ChatMediaModal;
